export const useWindow = () => ({...window});